import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import reduxStore from "./redux/store";
import { PersistGate } from 'redux-persist/integration/react'; 
import { GlobalStyles } from '@mui/material';

const { store, persistor } = reduxStore(); 

const theme = {
  ".MuiTooltip-tooltip"	: {
    "font-family": "Roboto regular, Helvetica, Arial, sans-serif !important",
    fontWeight:"300 !important",
    fontSize:"12px !important",
    lineHeight: "16px !important",
    color: "#FFFFFF !important",
    backgroundColor:"#3D3D3D !important"
  },
  ".MuiTooltip-arrow" : {
    color:"#3D3D3D !important"
  },
  ".MuiTableCell-root": {
    whiteSpace: "nowrap !important",
    fontSize:"14px !important",
    lineHeight: "24px !important",
    color: "#001317 !important"
  },
  ".MuiTableSortLabel-root:hover":{
    color:"inherit !important"
  },
  ".MuiTableSortLabel-root:focus":{
    color:"inherit !important"
  },
  ".MuiTableCell-body": {
    "font-family": "Roboto regular, Helvetica, Arial, sans-serif !important"
  },
  ".MuiTableRow-root.Mui-selected": {
    backgroundColor: "#E6F6FA !important"
  },
  ".MuiTableCell-head, .MuiTableCell-footer": {
    "font-family": "Roboto medium, Helvetica, Arial, sans-serif !important"
  },
  ".MuiTableSortLabel-root":{
    "justify-content": "space-between !important",
    "width" : "100% !important"
  },
  ".MuiPaginationItem-root": {
    fontSize: "12px !important",
    color: "#00A6CA !important",
  },
  ".MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#00A6CA !important",
    color: "#fff !important",
    borderColor: "#00A6CA !important",
  },
  ".MuiPaginationItem-page:hover": {
    backgroundColor: "#00A6CA !important",
    color: "#fff !important",
    borderColor: "#00A6CA !important",
  },
  ".MuiPaginationItem-previousNext": {
    borderColor: "#00A6CA !important",
  },
  ".MuiPaginationItem-previousNext:hover": {
    backgroundColor: "#00A6CA !important",
    color: "#fff !important",
    borderColor: "#00A6CA !important",
  },
  ".MuiPaginationItem-previousNext.Mui-disabled": {
    backgroundColor: "#FCFCFC !important",
    color: "#BDBDBD !important",
    borderColor: "#BDBDBD !important",
  },
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}> 
        <BrowserRouter>
          <GlobalStyles styles = {theme} />
          <App /> 
        </BrowserRouter>
      </PersistGate>
    </Provider>   
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
